import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to a hash anchor whenever the URL hash changes (incl. on page load
 * when arriving via a /#anchor link).
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    let attempts = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts < 10) {
        attempts += 1;
        setTimeout(tick, 100);
      }
    };
    setTimeout(tick, 60);
  }, [pathname, hash]);
  return null;
}
